import { registry } from "echart-table-library";
import { demoTooltip } from "./demoTooltip";
import { renderStatusCell } from "./renderStatusCell";
import { renderBasicInformationStatusCell } from "./renderBasicInformationStatusCell";
import { renderSelectCheckbox } from "./renderSelectCheckbox";
import { currentInkTooltip } from "./currentInkTooltip";
import { paperUsageTooltip } from "./paperUsageTooltip";
import { printedColorUsageTooltip } from "./printedColorUsageTooltip";
import { printOverviewTooltip } from "./printOverviewTooltip";

/**
 * Registers the application's business callbacks into the library registry
 * (D4 / convention section 40). Invoked once in `main.tsx`.
 *
 * Widget configs reference these by `$callback` name — no business function
 * ever enters the library.
 */
export function registerAppCallbacks(): void {
  registry.register("demoTooltip", demoTooltip);
  registry.register("renderStatusCell", renderStatusCell);
  registry.register("renderBasicInformationStatusCell", renderBasicInformationStatusCell);
  registry.register("renderSelectCheckbox", renderSelectCheckbox);
  registry.register("currentInkTooltip", currentInkTooltip);
  registry.register("paperUsageTooltip", paperUsageTooltip);
  registry.register("printedColorUsageTooltip", printedColorUsageTooltip);
  registry.register("printOverviewTooltip", printOverviewTooltip);
}
